import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
        name: 'firstWordsLetterToUppercase'
      })
export class FirstWordsLetterToUppercasePipe implements PipeTransform {

  private static capitalizeFirstLetter(word: string): string {
    return word.charAt(0).toUpperCase().concat(word.substring(1));
  }

  transform(value: any, ...args: any[]): any {

    if (value === undefined) {
      return '';
    }

    const splitWord = value.toLowerCase().split(' ');

    return splitWord.map(word => FirstWordsLetterToUppercasePipe.capitalizeFirstLetter(word))
                    .join(' ');
  }
}
